export default require("../templates/Home").default
